import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from 'src/shared/globals';

@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})
export class MyPropertyService {


  // tslint:disable-next-line: variable-name
  constructor(private httpService: HttpClient, private global: Globals) {
  }

  public getActiveProperty(): Observable<any> {
    let apiUrlGetProperty = this.global.apiUrl;
    apiUrlGetProperty += 'property/GetActiveProperties';
    return this.httpService.get(apiUrlGetProperty);
  }

  public getPendingProperty(): Observable<any> {
    let apiUrlGetProperty = this.global.apiUrl;
    apiUrlGetProperty += 'property/GetPendingProperties';
    return this.httpService.get(apiUrlGetProperty);
  }

  public getRejectedProperty(): Observable<any> {
    let apiUrlGetProperty = this.global.apiUrl;
    apiUrlGetProperty += 'property/GetRejectedProperties';
    return this.httpService.get(apiUrlGetProperty);
  }

  public getSoldProperty(): Observable<any> {
    let apiUrlGetProperty = this.global.apiUrl;
    apiUrlGetProperty += 'property/GetSoldProperties';
    return this.httpService.get(apiUrlGetProperty);
  }

  public approve(key: string, email: string): Observable<any> {
    let apiUrlApproveProperty = this.global.apiUrl;
    apiUrlApproveProperty += 'property/approve?key=' + key;
    apiUrlApproveProperty += '&email=' + email;
    return this.httpService.get(apiUrlApproveProperty);
  }

  public reject(key: string, email: string): Observable<any> {
    let apiUrlRejectProperty = this.global.apiUrl;
    apiUrlRejectProperty += 'property/reject?key=' + key;
    apiUrlRejectProperty += '&email=' + email;
    return this.httpService.get(apiUrlRejectProperty);
  }

  public Delete(Id: number): Observable<any> {
    let apiUrlDeleteProperty = this.global.apiUrl;
    apiUrlDeleteProperty += 'property/DeleteProperty?Id=' + Id;
    return this.httpService.get(apiUrlDeleteProperty);
  }

  public markSoldProperty(Id: number): Observable<any> {
    let apiUrlMarkSoldProperty = this.global.apiUrl;
    apiUrlMarkSoldProperty += 'property/MarkSoldProperty?Id=' + Id;
    return this.httpService.get(apiUrlMarkSoldProperty);
  }
}
